import { AccountTariff } from './account';

export enum ServerType {
  MT4 = 'mt4',
  MT5 = 'mt5',
  TP = 'tp',
  CT = 'ct'
}

export interface Availability {
  isAvailable: boolean;
  reason: string;
}

export interface Servers {
  name: ServerType;
  isEnabled: boolean;
  reason: string;
}

/**
 * Account tariff type.
 */
export class Tariff {
  id: number;
  name: string;
  type: AccountTariff;
  isDemo: boolean;
  isPromo: boolean;
  promoId: number;
  sort: number;
  servers: Servers[];
  leverages: number[];
  currencies: string[];
  limit: number;
  deposit: number;
  mt4Group: string;
  mt5Group: string;
  balanceMultiplier: number;
  defaultRole: string;
  comment: string;
  availability: Availability;
  isSwapFreeDisableDefault: boolean;

  /** Поиск тарифа по типу.
   * @param {Tariff[]} tariffs Список тарифов
   * @param {string} type Тип нужного тарифа
   * @returns {Tariff} Найденный тариф
   */
  static byType(tariffs: Tariff[], type: string): Tariff {
    return tariffs.find(t => t.type.toLowerCase() === type.toLowerCase());
  }

  static getServersName(servers: Servers[]): ServerType[] {
    return servers.map(server => server.name);
  }
}
